import { call, put } from 'redux-saga/effects';
import api from '../../services/api';

import { Creators as NewspaperCreators } from '../ducks/newspaper';

export function* getNewspaper(params) {
  const apiParams = params.id ? params.id : null;
  const response = yield call(api.get, `v1/newspapers/${params.id}/editions`);
  if (response.ok) {
    yield put(NewspaperCreators.getNewspaperSuccess(response.data));
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/newspaper.js